import { ModalService } from 'pf-frontend-common/src/service/modal/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { BackendConfigEnvPlatformEnum } from 'common/data/backend/config/env-platform.enum';
import { CountryCodeEnum } from 'common/data/country/code.enum';
import { configGetCountry } from 'common/helper/config/get-country';
import { configGetEnv } from 'common/helper/config/get-env';
import { configGetSettings } from 'common/helper/config/get-settings';
import { PreactView } from 'common/module/preact/view';
import { UserForgotPasswordTemplate } from 'common/module/user/forgot-password/template';
import { UserForgotPasswordViewStoreFactory } from 'common/module/user/forgot-password/view-store.factory';
import { UserPopupView } from 'common/module/user/popup/view';
import { UserRegistrationTemplate } from 'common/module/user/registration/template';
import { UserRegistrationViewStoreFactory } from 'common/module/user/registration/view-store.factory';
import { UserSignInTemplate } from 'common/module/user/sign-in/template';
import { UserSignInTemplateRefactored } from 'common/module/user/sign-in/template-refactored';
import { UserSignInTemplate2 } from 'common/module/user/sign-in/template2';
import { UserSignInViewStoreFactory } from 'common/module/user/sign-in/view-store.factory';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { UserSignInStatsService } from 'common/service/user-sign-in-stats/service';

export function UserPopupViewFactory(): UserPopupView {
  const countryCode = configGetCountry().code;
  const isNewTemplateRequired =
    countryCode === CountryCodeEnum.ae && configGetEnv().platform === BackendConfigEnvPlatformEnum.mobile;

  let userSignInTemplate = UserSignInTemplate;
  if (isNewTemplateRequired) {
    userSignInTemplate = UserSignInTemplateRefactored;
  } else if (countryCode === CountryCodeEnum.ma) {
    userSignInTemplate = UserSignInTemplate2;
  }

  return new UserPopupView(
    UserAuthenticationService(),
    ModalService(),
    WindowService(),
    StatsGtmProviderService(),
    configGetSettings(),
    UserSignInStatsService(),
    new PreactView(userSignInTemplate, UserSignInViewStoreFactory()),
    new PreactView(UserForgotPasswordTemplate, UserForgotPasswordViewStoreFactory()),
    isNewTemplateRequired ? null : new PreactView(UserRegistrationTemplate, UserRegistrationViewStoreFactory())
  );
}
